// extracted by mini-css-extract-plugin
export default {"icons":"DetailCards_icons__gGbx0","greyText":"DetailCards_greyText__l8kIE"};